import { FC, PropsWithChildren } from 'react';

import './row-edit-button.scss';

/*
 * The one "edit this row" action on the Fleet Files page, shared by both grids so they read the same:
 * a muted pencil before the row's code, in the first column, where it is visible without scrolling
 * sideways. The pencil always means a single row; page-level actions are text buttons in the card
 * header (e.g. BULK EDIT LINKS, ADD PROVIDER CODE).
 */
export const RowEditButton: FC<PropsWithChildren<{ label: string; onClick: () => void }>> = ({
  label,
  onClick,
  children
}) => (
  <button type="button" className="row-edit-button" aria-label={label} onClick={onClick}>
    <span className="material-icons" aria-hidden>
      edit
    </span>
    <span>{children}</span>
  </button>
);
